import Typography from '@ui/Typography';
import React from 'react';
import TagMentionInput from '../TagMentionInput/TagMentionInput';

function CreatePostForm(props) {
  const { error, message, onChange } = props;

  return (
    <div className="flex w-full flex-col gap-2">
      <div className="flex-1 rounded-md bg-primary-light-1">
        <TagMentionInput
          value={message}
          onChange={onChange}
          style={{
            input: { overflow: 'auto', height: '30vh' },
            highlighter: {
              overflow: 'hidden',
              height: '30vh',
            },
            control: {
              fontSize: '16px',
            },
          }}
          placeholder="What would you like to share?"
        />
      </div>

      {error && (
        <Typography variant="caption" color="error">
          {error}
        </Typography>
      )}

      {/* {previewUrls.length > 0 && (
        <div className="flex gap-2">
          {previewUrls.map((url) => (
            <div key={url} className="h-52 w-full max-w-fit rounded-sm">
              <Image
                src={getQualifiedImageUrl(url)}
                alt="preview"
                fill
                objectFit="cover"
              />
            </div>
          ))}
        </div>
      )} */}
    </div>
  );
}

export default CreatePostForm;
